import * as L from '../styles/AccountTableStyles';
import { RouteComponentProps } from 'react-router';
import DocumentTitle from 'react-document-title';
import React from 'react';
import AccountTableLogic from './AccountTableLogic';
import { useEffect, useState } from "react";
import UserService from '@/services/UserService';
import Auth from '@/Auth/Auth';
import { AccountsAutorized, AccountsUsed } from '@/services/SubscriptionService';
import { useLocation } from "react-router";


interface RouteParams { };

interface Props extends RouteComponentProps<RouteParams> { };
interface LocationState
{
    data?: string; // Puede ser undefined si no se proporciona
}

export const CurrentAccounts: React.FunctionComponent<Props> = (props, context) =>
{
    const user = Auth.getUserProfile();
    const [accountsUsed, setAccountsUsed] = useState<AccountsUsed[]>();
    const [accountsAutorized, setAccountsAutorized] = useState<AccountsAutorized[]>();
    const [error, setError] = useState({ message: false });
    const [loading, setLoading] = useState<boolean>(true);
    const [refresh, setRefresh] = useState<boolean>(false);

    const { state } = useLocation<LocationState>();
    const bankAccountUsedInOperation: string | undefined = state?.data;

    useEffect(() =>
    {
        getBankAccountInfo();
    }, [refresh]);


    const getBankAccountInfo = () =>
    {
        setLoading(true);

        if (bankAccountUsedInOperation != undefined)
        {
            Promise.all([UserService.getBankAccountsAutorized(user.id), UserService.getBankAccountsUsedWithParam(user.id, bankAccountUsedInOperation)])
                .then(([accountsDataAutorized, accountsDataUsed]) =>
                {
                    setAccountsAutorized(accountsDataAutorized);
                    setAccountsUsed(accountsDataUsed);
                })
                .catch(error =>
                {
                    setError(error);
                })
                .finally(() =>
                {
                    setLoading(false);
                });
        } else
        {
            Promise.all([UserService.getBankAccountsAutorized(user.id), UserService.getBankAccountsUsed(user.id)])
                .then(([accountsDataAutorized, accountsDataUsed]) =>
                {
                    setAccountsAutorized(accountsDataAutorized);
                    setAccountsUsed(accountsDataUsed);
                })
                .catch(error =>
                {
                    setError(error);
                })
                .finally(() =>
                {
                    setLoading(false);
                });
        }


    }

    return (
        <React.Fragment>
            <DocumentTitle title="IronIA - Cuentas Corrientes">
                <L.Wrapper>
                    <L.TitleContainer>
                        <L.Title>Cuentas Corrientes</L.Title>
                    </L.TitleContainer>
                    <AccountTableLogic
                        setRefresh={setRefresh}
                        dataUsed={accountsUsed}
                        dataAutorized={accountsAutorized}
                        loading={loading}
                        error={error}
                    />
                </L.Wrapper>
            </DocumentTitle>
        </React.Fragment>
    );
};